function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import PropTypes from 'prop-types';
import { BaseButton } from './_BaseButton';
import { makeComplexAttributePropType } from './../../utils/helpers';
import { FontSize, PadMarg, Display } from './../../enhancers';
import { localPropsMap, breakpoint, SIZES, SIZES_ROUND, WIDTHS, HEIGHTS, THEMES } from './params';
/* Adding enhancers */

var PadMargedButton = function PadMargedButton(props) {
  return React.createElement(PadMarg, _extends({
    InputComponent: BaseButton
  }, props));
};

var FontSizedButton = function FontSizedButton(props) {
  return React.createElement(FontSize, _extends({
    InputComponent: PadMargedButton,
    propsMap: {
      'fsize': 'fontSize'
    }
  }, props));
};

var Button = function Button(props) {
  return React.createElement(Display, _extends({
    InputComponent: FontSizedButton
  }, props.round ? {} : SIZES[props.size][1], props));
};

Button.size = SIZES;
Button.sizeRound = SIZES_ROUND;
Button.width = WIDTHS;
Button.theme = THEMES;
Object.assign(Button, {
  localPropsMap: localPropsMap,
  breakpoint: breakpoint
});
var string = PropTypes.string,
    bool = PropTypes.bool,
    node = PropTypes.node,
    oneOf = PropTypes.oneOf,
    func = PropTypes.func,
    oneOfType = PropTypes.oneOfType;
Button.propTypes =
/*#__PURE__*/
_objectSpread({
  /**
   * Node type
   */
  as:
  /*#__PURE__*/
  oneOfType([string, node]),

  /**
   * Custom CSS class name
   */
  className: string,

  /**
   *  attr tagret='_blank'
   */
  blank: bool,

  /**
   *  Link href
   */
  href: string,

  /**
   * React router link to
   */
  to: string,

  /**
   * Primary content
   */
  children: node,

  /**
   * Primary content
   */
  content: node,

  /**
   *  Basic button
   */
  basic: bool,

  /**
   * Disabled
   */
  disabled: bool,

  /**
   * is pressed
   */
  pressed: bool,

  /**
   * is hovered
   */
  hovered: bool,

  /**
   *  Is primary
   */
  primary: bool,

  /**
   *  Is secondary
   */
  secondary: bool,

  /**
   *  Is inverted
   */
  inverted: bool,

  /**
   *  Is inverted
   */
  whiteBg: bool,

  /**
   *  Is opacity white
   */
  opacity: bool,

  /**
   *  Is rounded
   */
  rounded: bool,

  /**
   *  Is round (in a shape of circle)
   */
  round: bool,

  /**
   *  Sizes
   */
  size:
  /*#__PURE__*/
  oneOf(
  /*#__PURE__*/
  [].concat(
  /*#__PURE__*/
  _toConsumableArray(
  /*#__PURE__*/
  Object.keys(SIZES)),
  /*#__PURE__*/
  _toConsumableArray(
  /*#__PURE__*/
  Object.keys(SIZES_ROUND)))),

  /**
   *  Widths
   */
  width:
  /*#__PURE__*/
  oneOf(
  /*#__PURE__*/
  Object.keys(WIDTHS))
},
/*#__PURE__*/
makeComplexAttributePropType([
/*#__PURE__*/
Object.keys(localPropsMap),
/*#__PURE__*/
// eslint-disable-line array-element-newline
Object.keys(breakpoint)],
/*#__PURE__*/
Object.keys(HEIGHTS)), {
  /**
   * Indicates if there should not be any margin
   * between this button and the previous one
   */
  noSpacing: bool,

  /**
   *  Fluid width
   */
  fluid: bool,
  fluidL: bool,
  fluidM: bool,
  fluidS: bool,
  fluidXS: bool,

  /**
   *  Has shadow
   */
  shadow: bool,

  /**
   *  Is in loading state
   */
  loading: bool,

  /**
   * Button icon
   */
  icon: node,

  /** * On click callback */
  onClick: func,

  /** Function to make inner ref (from toolptips mostly) */
  innerRef: func,

  /** Function to make ref */
  ref: func,

  /** Themes */
  theme:
  /*#__PURE__*/
  oneOf(
  /*#__PURE__*/
  Object.keys(THEMES)),

  /** Display */
  display: string
}, FontSizedButton.propTypes, PadMargedButton.propTypes, Display.propTypes);
Button.displayName = 'Button';
Button.defaultProps = {
  size: 'm',
  rounded: true,
  basic: false,
  theme: 'default',
  display: 'inline-block'
};
export { Button };